import { tqlQueryFromInput } from '@townsquare/tql/query';
import { ComparatorOperator } from '@townsquare/tql/types';

export const DEFAULT_TQL_QUERY = tqlQueryFromInput({
	input: [{ fieldName: 'archived', fieldValue: false, comparator: ComparatorOperator.EQUALS }],
});
